import PropTypes from 'prop-types';

const { shape, arrayOf } = PropTypes;

export default arrayOf(shape({}));
